export const FilasTabla = ({ elementos, itemsFilas, elemNoEncontrado, ocultarEncabezadoMobile, mostrarElem, classNameFilas}) => {

   return (
        <>
            <div className={'alturaScrollTabla scrollAdmin scrollArea px-3 px-sm-0 ' + (!ocultarEncabezadoMobile? 'scrollAdminEncabezadoMobile ' : ' ') + classNameFilas}>
                    
                    {elementos.length !== 0 ?

                        elementos.map(function (elem, i) {
                            return (
                                mostrarElem === undefined || mostrarElem(elem)?
                                <div id={'idElem' + i} className='row py-3 px-0 px-sm-3 bordeTablas align-items-center mx-0 marginTabla itemsTabla position-relative' >

                                    {itemsFilas(elem)}
                                </div>
                                :
                                <></>                              
                                
                                )
                        })
                        :
                        <>
                            <p className='text-center mt-4'>{'No se encontraron ' + elemNoEncontrado}</p>
                        </>
                    }
                    
                </div>
        </>
    );
}
